(() => {
  window.swinger.eventHub.register('click', '[data-copy]', (e) => {
    const elem = window.swinger.eventHub.getTarget(e).closest('[data-copy]');
    const text = elem.getAttribute('data-copy');

    window.swinger.clipboard.copy(text);

    e.preventDefault();
  });
})();
